<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <div class="text-center">
            <h4>Reporte de Ventas</h4>
            <span class="text-center" style="font-weight: 400; font-size: small;">
              Ingresa los datos y realiza tu busqueda
            </span>
          </div>
          <hr class="horizontal dark" />
          <div class="row pl-2 pr-2">
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Desde</label>
              <datepicker
                v-model="fechaInicio"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Hasta</label>
              <datepicker
                v-model="fechaFin"
                :="basicConfigDatePicker"
                :name="String(n)"
              ></datepicker>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Documento de Identidad</label>
              <input type="text" class="form-control" v-model="documentoIdentidad">
            </div>
            <!-- <div class="col-md-2">
              <label class="form-control-label">ID Afiliado</label>
              <input type="text" class="form-control" v-model="idAfiliado">
            </div> -->
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Departamento</label>
              <vue-select
                :options="departmentosOptions"
                label="text"
                v-model="departamento"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Programa</label>
              <input type="text" class="form-control" v-model="programa">
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Código Vendedor</label>
              <input type="text" class="form-control" v-model="codigoVendedor">
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Nombre Vendedor</label>
              <input type="text" class="form-control" v-model="nombreVendedor">
            </div>
            <div class="col-md-2">
              <label for="example-text-input" class="form-control-label">Estado</label>
              <vue-select
                :options="statusOptions"
                label="text"
                v-model="estado"
                :reduce="(option) => option.value"
              ></vue-select>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-2">
              <button class="btn btn-addiuva-dark w-100" style="margin-top: 30px;"  @click="getVentas" title="Generar">
                <i class="fas fa-search pr-1"></i> Generar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div class="row p-2">
          <Toast />
          <DataTable :value="ventas" ref="dtventas" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay ventas que mostrar. </center></template>
            <Column field="id_venta" header="ID Venta" sortable></Column>
            <!-- <Column field="id_asegurado" header="ID Asegurado" sortable></Column> -->
            <Column field="documento_identidad" header="Doc. Identidad" sortable></Column>
            <Column field="tipo_cobertura" header="Programa" sortable></Column>
            <Column field="departamento" header="Departamento" sortable></Column>
            <Column field="sucursal" header="Sucursal" sortable></Column>
            <Column field="factura" header="Factura" sortable></Column>
            <Column field="fecha_hora_venta" header="Fecha/Hora de Venta" sortable></Column>
            <Column field="total_factura" header="Precio Total Factura" sortable></Column>
            <Column field="codigo_usuario_vendedor" header="Código Vendedor" sortable></Column>
            <Column field="nombres_apellidos_vendedor" header="Nombre Vendedor" sortable></Column>
            <Column field="comentario_adicional" header="Comentarios" sortable></Column>
            <Column field="fecha_registro_venta" header="Fecha Registro Venta" sortable></Column>
            <Column field="estado" header="Estado" sortable></Column>
            <template #paginatorstart>
              <button class="btn btn-light" @click="exportCSV($event)" title="Exportar" v-if="ventas.length>0">
                <i class="fas fa-download"></i> Exportar CSV
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Datepicker from 'vuejs3-datepicker';
import Toast from 'primevue/toast';
import axios from 'axios';
import authHeader from '../services/auth-header';
export default {
  name: "reporte-ventas",
  components: {
    VueSelect,
    DataTable,
    Column,
    Toast,
    Datepicker
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      fechaInicio: null,
      fechaFin:null,
      idAfiliado: null,
      documentoIdentidad: null,
      programa: null,
      departamento: '',
      departmentosOptions: [
        {
          text: 'Todos',
          value: '',
        },
        {
          text: 'Beni',
          value: 'BO-B',
        },
        {
          text: 'Chochabamba',
          value: 'BO-C'
        },
        {
          text: 'Chuquisaca',
          value: 'BO-H'
        },
        {
          text: 'La Paz',
          value: 'BO-L'
        },
        {
          text: 'Pando',
          value: 'BO-N'
        },
        {
          text: 'Oruro',
          value: 'BO-O'
        },
        {
          text: 'Potosí',
          value: 'BO-P'
        },
        {
          text: 'Santa Cruz',
          value: 'BO-S'
        },
        {
          text: 'Tarija',
          value: 'BO-T'
        }
      ],
      codigoVendedor: null,
      nombreVendedor: null,
      estado: null,
      statusOptions: [
        {
          text: 'TODOS',
          value: ''
        },
        {
          text: 'Activo',
          value: 'true'
        },
        {
          text: 'Anulado',
          value: 'false'
        }
      ],
      ventas: [],
      showProfileDropdown: false
    };
  },
  methods: {
    getVentas() {
      this.ventas = [];
      let payload = {
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '',
        "documento_identidad" : this.documentoIdentidad ?? '',
        "id_afiliado" :   this.idAfiliado ?? '',
        "departamento" :  this.departamento ?? '',
        "tipo_cobertura" : this.programa ?? '',
        "codigo_vendedor" :  this.codigoVendedor ?? '',
        "nombre_vendedor" : this.nombreVendedor ?? '',
        "estado" :  this.estado ?? ''
      }
      // Send Data by Axios
      let url = this.API_URL + "/reporte_ventas";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let ventas = [];
            data.forEach(a => {
              ventas.push({
                id_venta: a.id_venta ?? '',
                id_asegurado: a.id_asegurado ?? '',
                documento_identidad: a.documento_identidad ?? '',
                tipo_cobertura: a.tipo_cobertura ?? '',
                departamento: a.departamento ?? '',
                sucursal: a.sucursal ?? '',
                factura: a.factura ?? '',
                fecha_hora_venta: a.fecha_hora_venta ?? '',
                total_factura: a.total_factura ?? '',
                codigo_usuario_vendedor: a.codigo_usuario_vendedor ?? '',
                nombres_apellidos_vendedor: a.nombres_apellidos_vendedor ?? '',
                comentario_adicional: a.comentario_adicional ?? '',
                fecha_registro_venta: a.fecha_registro_venta ?? '',
                estado: a.estado ?? '',
              });
            });
            ventas.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
            });
            this.ventas = ventas;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        //this.$router.push({name: 'Dashboard'});
      }
    },
    exportCSV() {
      this.$refs.dtventas.exportCSV();
    }
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    // this.validateRoute();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
.vs__dropdown-toggle {
  border-color: #CDCDCD !important;
}
</style>